import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PPIService from "../../services/PPIService";
import Modal from "react-modal";
import { useNavigate, useLocation } from "react-router-dom";

Modal.setAppElement("#root");

const IssueDigitalCard = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const {} = location.state || {}; // You can pass this from the previous step

  useEffect(() => {
    const issueCard = async () => {
      try {
        const result = await PPIService.issueInstantDigitalCard(); // Replace with actual method and param

        if (!result.success || result.data.status !== "SUCCESS") {
          Swal.fire(
            "Oops!",
            result.data?.message || "Card issuance failed",
            "error"
          );
          return;
        }

        const responseData = result.data;
        if (responseData.status === "SUCCESS") {
          Swal.fire("Success!", result.data.message, "success");
          // Optionally redirect after success
          navigate("/dashboard", { state: {} });
        } else {
          if (
            responseData.message ===
            "Instant digital card has already been issued."
          ) {
            navigate("/dashboard", { state: {} });
            return;
          }
          Swal.fire("Oops!", responseData.message, "error");
        }
      } catch (error) {
        Swal.fire(
          "Error",
          error.response?.data?.message || "Something went wrong",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    issueCard();
  }, [navigate]);

  return (
    <div className="bg-light py-3 px-3 min-vh-100 d-flex align-items-center justify-content-center">
      <div
        className="card shadow rounded-4 w-100"
        style={{ maxWidth: "1200px", minHeight: "300px" }}
      >
        <div className="card-body p-4 text-center">
          <h4 className="mb-4">PPI User Onboarding</h4>

          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mb-0 fw-semibold">
                Issuing virtual prepaid card...
              </p>
            </div>
          ) : (
            <p className="text-success">Card issued successfully!</p>
          )}

          <hr className="my-4" />
          <div className="text-center">
            <small className="text-muted d-block mb-1">ISSUED BY</small>
            <img
              src="/images/pine-labs-logo.png"
              alt="Pine Labs"
              style={{ height: "22px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssueDigitalCard;
